import { render, staticRenderFns } from "./bitacoraLoginPortalComercial.vue?vue&type=template&id=b2b62dea"
import script from "./bitacoraLoginPortalComercial.vue?vue&type=script&lang=js"
export * from "./bitacoraLoginPortalComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports